angular.module('unica_campaign.campaign_services')

.factory('CampaignDeleteService', function ($http, getBaseApiURL) {

	var campaignDeleteService = {};

	campaignDeleteService.delete = function (campaignId) {
		return $http({
			method: 'DELETE',
			url: getBaseApiURL + '/campaign/delete/' + campaignId,
			data: { }
		}).then(function(result) {

			if ( result ) {
				return true;
			}

		});

	};

	return campaignDeleteService;
});